/**
 * Google Maps API key, sourced from the VITE_GOOGLE_MAPS_API_KEY environment
 * variable (see .env). Used by every <ReactLeafletGoogleLayer /> in the app.
 *
 * Note: like all VITE_* values, this is inlined into the client bundle at build
 * time and is visible in the browser — it is not a secret. Access is controlled
 * via Google Cloud key restrictions, not by hiding the value. Centralizing it
 * here means rotating the key is a single change in .env.
 */
export const GOOGLE_MAPS_API_KEY = import.meta.env.VITE_GOOGLE_MAPS_API_KEY;
